export enum QueueStrategy {
    RING_ALL = "Звонить всем",
    LEAST_RECENT = "Наиболее давний",
    FEWEST_CALLS = "Реже вызываемый",
    RANDOM = "Случайно",
    ROUND_ROBIN_MEMORY = "По кругу",
    ROUND_ROBIN_ORDERED = "По кругу",
    WEIGHT_RANDOM = "Случайно с учетом занятости"
}
